var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterHeatericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M496 88c0-39.7-32.3-72-72-72s-72 32.3-72 72c0 31.3 20.1 58 48 67.9v84.8c0 10.3 6.7 19 16 22.1v158.1c0 32.6-26.5 59.1-59.1 59.1H291c-32.6 0-59.1-26.5-59.1-59.1V384h8c4.4 0 8-3.6 8-8v-24c4.4 0 8-3.6 8-8v-24h12.7c10.6 0 19.3-8.7 19.3-19.3V35.3c0-10.6-8.7-19.3-19.3-19.3H35.3C24.7 16 16 24.7 16 35.3v265.4c0 10.6 8.7 19.3 19.3 19.3H48v24c0 4.4 3.6 8 8 8v24c0 4.4 3.6 8 8 8h8v17.4c-9.3 3.3-16 12.2-16 22.6s6.7 19.3 16 22.6V488c0 4.4 3.6 8 8 8s8-3.6 8-8v-41.4c9.3-3.3 16-12.2 16-22.6s-6.7-19.3-16-22.6V384h8c4.4 0 8-3.6 8-8v-24c4.4 0 8-3.6 8-8v-24h80v24c0 4.4 3.6 8 8 8v24c0 4.4 3.6 8 8 8h8v36.9c0 41.4 33.7 75.1 75.1 75.1H357c41.4 0 75.1-33.7 75.1-75.1V262.8c9.3-3.1 16-11.8 16-22.1v-84.8C475.9 146 496 119.3 496 88zM80 432c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm152-128V86.5c0-12.4-10.1-22.5-22.5-22.5h-115C82.1 64 72 74.1 72 86.5V304H35.3c-1.8 0-3.3-1.5-3.3-3.3V35.3c0-1.8 1.5-3.3 3.3-3.3h233.4c1.8 0 3.3 1.5 3.3 3.3v265.4c0 1.8-1.5 3.3-3.3 3.3M88 304V86.5c0-3.6 2.9-6.5 6.5-6.5h114.9c3.6 0 6.5 2.9 6.5 6.5V304M88 352v16H72v-16m-8-16v-16h32v16m144-16v16h-32v-16zm-8 32v16h-16v-16zm200-111.3c0 4-3.3 7.3-7.3 7.3h-1.4c-4 0-7.3-3.3-7.3-7.3v-81.2c2.6.3 5.3.5 8 .5s5.4-.2 8-.5zm-8-96.7c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 40c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM424 120c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM424 80c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM448 72c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8zM400 104c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM464 80c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM384 80c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.5-8-8-8zM448 104c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM400 56c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM152 200c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 80c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.3 234.3-8 8c-3.1 3.1-3.1 8.2 0 11.3 1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l8-8c3.1-3.1 3.1-8.2 0-11.3a8.15 8.15 0 0 0-11.4 0zM128 112h48c4.4 0 8-3.6 8-8s-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8s3.6 8 8 8zM136 128c-4.4 0-8 3.6-8 8s3.6 8 8 8h32c4.4 0 8-3.6 8-8s-3.6-8-8-8zM120 176h64c4.4 0 8-3.6 8-8s-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8s3.6 8 8 8z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterHeatericon);
export default __webpack_public_path__ + "static/media/waterHeatericon.c9ae627203a763c308f24c4a89c9608f.svg";
export { ForwardRef as ReactComponent };